import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';
import { useContextCurrentSite } from 'contexts';
import { useContextProperties } from 'contexts/properties';
import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import BreadCrumb from 'components/breadcrumb';
import BarSeats from 'components/barsSeats';
import { LOCALHOST, getSite } from 'constants/sites';
import useDebounce from 'dataProvider/hooks/useDebounce';
import { Button } from 'components';
import { TYPES } from '../../envs';

import CustomMap from '../../components/homeMap/customMap';
import Tag from '../../components/tag';
import Tags from '../../components/tags';
import Autocomplete from '../../components/autocomplete';

import { excludedGrandParentIds } from '../../core/constants';

const MainMultiplyRegional = ({
  allRegions,
  mapData,
  onChangeLocation,
  partiesWinners
}) => {
  const { params } = useContextProperties();
  const resultOrigin = useContextResultOrigin();

  const { matchParams } = useContextMatchParams();
  const { electionNumber, subtype, placesId, type, year, community, country } =
    matchParams;

  const placesIdList = placesId.split('-');

  const [rows, setRows] = useState([]);
  const [autocomplePro, setAutocomplePro] = useState('');
  const [autocompleCom, setAutocompleCom] = useState('');
  const [autocompleMun, setAutocompleMun] = useState('');
  const site = getSite();

  const partyWinnerFlat = Object.values(partiesWinners).flat(1);
  const { currentSite } = useContextCurrentSite();

  useEffect(() => {
    if (params) {
      setRows(
        params.sites[site === LOCALHOST ? currentSite : site].views[
          type.toLocaleLowerCase()
        ].homeMultiRegions.rows
      );
    }
  }, [params, site, currentSite, type]);

  const { result: dataPlacesRegion } = usePlacesProvider({
    type: 'REGION',
    sortby: 'name',
    excludedGrandParentIds,
    electionType: type
  });

  const { result: dataPlacesProvince } = usePlacesProvider({
    type: 'PROVINCE',
    sortby: 'name',
    parentId: community,
    excludedGrandParentIds,
    electionType: type
  });
  const debouncedSearch = useDebounce(autocompleMun, 400);
  const { result: dataPlacesTown } = usePlacesProvider({
    sortby: 'name',
    name: debouncedSearch,
    type: 'TOWN',
    size: 10,
    excludedGrandParentIds,
    electionType: type
  });
  const { result: dataPlacesTownPrincipals } = usePlacesProvider({
    sortby: 'main',
    type: 'TOWN',
    size: 10,
    excludedGrandParentIds,
    electionType: type
  });
  const dataBreadcrumb = [
    {
      name: 'Autonómicas',
      ineId: 'C108'
    }
  ];

  if (
    !params ||
    !rows ||
    !dataPlacesRegion ||
    !dataPlacesProvince ||
    !dataPlacesTown ||
    !dataPlacesTownPrincipals
  ) {
    return <LoadingPlaceholder />;
  }
  const textPactButton =
    params?.sites[site === LOCALHOST ? currentSite : site].labels
      .pactometro_url || '#';

  const content = rows.map((row, index) => (
    <div className={row.class} key={`row-${index + 1}`}>
      {row.columns.map((column, idx) => (
        <div className={column.class} key={`col-${idx + 1}`}>
          {column.components.map(item => (
            <div className={item.class || ''} key={item.module}>
              {/* PlacesProvider REGION PROVINCE TOWN */}
              {item.module === 'SELECTORS' && (
                <Fragment>
                  <div className="row-places">
                    {/* PlacesProvider REGION */}
                    {dataPlacesRegion && (
                      <div className="col-places col-places--region">
                        <Autocomplete
                          results={dataPlacesRegion.filter(d =>
                            autocompleCom
                              ? d.name
                                  .toLocaleLowerCase()
                                  .includes(autocompleCom.toLocaleLowerCase())
                              : d
                          )}
                          onChange={value => setAutocompleCom(value)}
                          onSelect={(event, select) => {
                            onChangeLocation(event, select);

                            setAutocompleCom('');
                          }}
                          placeholder="Buscar comunidad"
                          showArrow
                          type={type}
                          params={params}
                          year={year}
                        />
                      </div>
                    )}
                    {/* PlacesProvider PROVINCE */}
                    {dataPlacesProvince && (
                      <div className="col-places col-places--province">
                        <Autocomplete
                          results={dataPlacesProvince.filter(d =>
                            autocomplePro
                              ? d.name
                                  .toLocaleLowerCase()
                                  .includes(autocomplePro.toLocaleLowerCase())
                              : d
                          )}
                          onChange={value => setAutocomplePro(value)}
                          onSelect={(event, select) => {
                            onChangeLocation(event, select);

                            setAutocomplePro('');
                          }}
                          placeholder="Buscar provincia"
                          showArrow
                          type={type}
                          params={params}
                          year={year}
                        />
                      </div>
                    )}
                    {/* PlacesProvider TOWN */}
                    {dataPlacesTown && (
                      <div className="col-places col-places--town">
                        <Autocomplete
                          results={dataPlacesTown}
                          onChange={value => setAutocompleMun(value)}
                          onSelect={(event, select) => {
                            onChangeLocation(event, select);

                            setAutocompleMun('');
                          }}
                          placeholder="Buscar municipio"
                          showArrow
                          type={type}
                          params={params}
                          year={year}
                        />
                      </div>
                    )}
                  </div>
                  <BreadCrumb
                    dataBreadcrumb={dataBreadcrumb}
                    onClick={onChangeLocation}
                  />
                </Fragment>
              )}
              {item.module === 'MAP' && (
                <CustomMap
                  allMap
                  allRegions={allRegions}
                  country={country}
                  electionNumber={electionNumber}
                  electionType={type}
                  excludedGrandParentIds={excludedGrandParentIds}
                  isFiltered={false}
                  isRegional={type === TYPES.REGIONAL}
                  maps={mapData}
                  native
                  onChange={(event, _item) =>
                    onChangeLocation(event, _item, true)
                  }
                  partiesWinners={partyWinnerFlat}
                  partiesWinnersNoFlat={partiesWinners}
                  selectedPlace=""
                  showTooltipInfo
                  year={year}
                />
              )}
              {item.module === 'TAGS' && (
                <Fragment>
                  <h3 className="tags-title">
                    Resultado de las elecciones en:
                  </h3>
                  <div className="tags_container">
                    <Tags>
                      {dataPlacesTownPrincipals?.map(d => (
                        <Tag
                          key={`${d.ineId}-${d.name}`}
                          onClick={e => {
                            onChangeLocation(e, d);
                          }}
                          native
                          route={d.path}
                        >
                          {d.name}
                        </Tag>
                      ))}
                    </Tags>
                  </div>
                </Fragment>
              )}
              {item.module === 'BARINFO' &&
                placesIdList.map(place => (
                  <BarSeats
                    key={place}
                    place={place}
                    resultOrigin={resultOrigin}
                    year={year}
                    type={type}
                    elSubtype={subtype}
                    electionNumber={electionNumber}
                    site={site}
                  />
                ))}
              {item.module === 'BTN_PACTOMETER' && (
                <Button className="button--primary" link url={textPactButton}>
                  Pactómetro Elecciones 28M
                </Button>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  ));

  return <Fragment>{content}</Fragment>;
};

export default MainMultiplyRegional;

MainMultiplyRegional.propTypes = {
  allRegions: PropTypes.arrayOf(PropTypes.shape({})),
  mapData: PropTypes.arrayOf(PropTypes.shape({})),
  onChangeLocation: PropTypes.func,
  partiesWinners: PropTypes.shape({}),
  resultOrigin: PropTypes.shape({})
};
MainMultiplyRegional.defaultProps = {
  allRegions: [],
  mapData: [],
  onChangeLocation: () => {},
  partiesWinners: {},
  resultOrigin: {}
};
